$(() => {
	const cardContent = $('.bs-section--trust-tab-slider');
	const cardModule = cardContent.find('.bs-card__container');
	cardModule.each((index, element) => {
		$(element)
			.find('.bs-card__title, .bs-card__subtitle')
			.wrapAll('<div class="bs-card__details-wrapper" />');
	});
});
